import { render, staticRenderFns } from "./ServiceProgramList.vue?vue&type=template&id=5a834fbc&"
import script from "./ServiceProgramList.vue?vue&type=script&lang=js&"
export * from "./ServiceProgramList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports